// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bceaa08d","823":"f4b6083c"}[chunkId] + ".chunk.js";
};